import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Map as MapIcon, ArrowRight } from "lucide-react";
import { http } from "../lib/api";
import { DepartmentMap } from "./DepartmentMap";

export const CoveragePreviewCard = ({ isAdmin }) => {
  const [depts, setDepts] = useState(null);
  useEffect(() => { http.get("/coverage").then((r) => setDepts(r.data.departments)).catch(() => setDepts([])); }, []);
  return (
    <div className="border border-slate-200 bg-white rounded-md p-6 mb-8" data-testid="coverage-preview-card">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-display text-xl font-bold flex items-center gap-2"><MapIcon className="h-5 w-5 text-sky-600" />Zone d&apos;intervention</h3>
        <Link to="/carte" data-testid="coverage-preview-link" className="text-sm font-semibold text-sky-700 hover:underline inline-flex items-center gap-1">Voir la carte <ArrowRight className="h-4 w-4" /></Link>
      </div>
      {depts && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
          <DepartmentMap departments={depts} showAgents={isAdmin} compact />
          <div>
            <div className="font-display text-4xl font-extrabold" data-testid="coverage-preview-count">{depts.length}</div>
            <div className="text-sm text-slate-500 mb-3">département{depts.length > 1 ? "s" : ""} couvert{depts.length > 1 ? "s" : ""}</div>
            <div className="flex flex-wrap gap-1.5">
              {depts.map((d) => <span key={d.code} className="text-xs px-2 py-1 rounded bg-slate-100 text-slate-700">{d.name} ({d.code})</span>)}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
